<template>
  <div class="device-log-page" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="filter" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="5">
            <el-form-item :label="$t('device.device_number')">
              <el-input v-model="filter.number" :placeholder="$t('device.please_device_number')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('log.behavior_type')">
              <el-select
                clearable
                :placeholder="$t('log.select_behavior_type')"
                v-model="filter.type"
                style="width: 100%"
              >
                <el-option
                  v-for="(t,index) in logTypeArr"
                  v-if="index>0"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('device.time_frame')">
              <el-date-picker
                v-model="filterDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('control.to')"
                :start-placeholder="$t('control.start_date')"
                :end-placeholder="$t('control.over_date')"
                @change="clearChange"
                />
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="number" :label="$t('log.number')"></el-table-column>
        <el-table-column prop="name" :label="$t('log.name')"></el-table-column>
        <el-table-column prop="content" :label="$t('log.content')"> </el-table-column>
        <el-table-column prop="created_at" :label="$t('control.date')"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import deviceLogApi from '@/api/device/deviceLog'
import commonJs from '@/utils/common'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      logTypeArr: this.$t('log.logTypeArr'),
      tableData: [],
      pageInfo: {
        sortBy: 'id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        number: '',
        type: '',
        createTimeFrom: '', // 时间间隔开始
        createTimeTo: '' // 时间间隔结束
      },
      filterDate: [],
      cnt_all: 0
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      if(this.filterDate&&this.filterDate.length){
        this.filter.createTimeFrom = this.filterDate[0]
        this.filter.createTimeTo = this.filterDate[1]
      }else{
        this.filter.createTimeFrom = ''
        this.filter.createTimeTo = ''
      }
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      deviceLogApi.getDeviceLogList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    clearChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.filterDate = ''
        })
      }
    }
  }
  
};
</script>
<style lang='less'>
.device-log-page{
  width: 100%;
}

</style>